import { Controller } from "@hotwired/stimulus"

// Keeps a growing log element scrolled to the bottom as Turbo Stream
// appends push new lines into it.
export default class extends Controller {
  connect() {
    this.observer = new MutationObserver(() => this.scrollToBottom())
    this.observer.observe(this.element, { childList: true })
    this.scrollToBottom()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
